__turbopack_context__.v({
  "chatItem": "ChatItem-module__61ldXq__chatItem",
  "chatItemActive": "ChatItem-module__61ldXq__chatItemActive",
  "chatItem__date": "ChatItem-module__61ldXq__chatItem__date",
  "chatItem__line": "ChatItem-module__61ldXq__chatItem__line",
});
